import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tab-nav big-tab-nav--nav-container"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "big-tab-nav--view-label" }
const _hoisted_4 = {
  key: 1,
  class: "tab-nav tab-nav--nav-container"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "tab-nav--view-label" }
const _hoisted_7 = { class: "tab-nav--view-container" }
const _hoisted_8 = ["data-index"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.bigNav)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.views, (view, i) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(["big-tab-nav--view-item", {active: _ctx.active?.id === view.id}]),
              onClick: ($event: any) => (_ctx.switchTab(view))
            }, [
              _renderSlot(_ctx.$slots, "label", {
                view: view,
                active: _ctx.active
              }, () => [
                _createElementVNode("span", _hoisted_3, _toDisplayString(view.label || view.id), 1)
              ], true)
            ], 10, _hoisted_2))
          }), 256))
        ]))
      : (_openBlock(), _createElementBlock("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.views, (view, i) => {
            return (_openBlock(), _createElementBlock("li", {
              class: _normalizeClass(["tab-nav--view-item", {active: _ctx.active?.id === view.id}]),
              onClick: ($event: any) => (_ctx.switchTab(view))
            }, [
              _renderSlot(_ctx.$slots, "label", {
                view: view,
                active: _ctx.active
              }, () => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(view.label || view.id), 1)
              ], true)
            ], 10, _hoisted_5))
          }), 256))
        ])),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.views, (view, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(`tab-nav--view__${view.id}`),
          "data-index": index
        }, [
          (_ctx.active && _ctx.active?.id === view?.id || ((!_ctx.active || _ctx.active?.id !== view?.id) && !_ctx.hideInactive))
            ? _renderSlot(_ctx.$slots, view.id, {
                key: 0,
                index: index,
                view: view,
                active: _ctx.active,
                switchTab: _ctx.switchTab
              }, undefined, true)
            : _createCommentVNode("", true)
        ], 10, _hoisted_8))
      }), 256))
    ])
  ], 64))
}